export interface ISolarAccountBalanceRequest {
  igsCustomerNumber: string;
}
export class SolarAccountBalanceRequest implements ISolarAccountBalanceRequest {
  igsCustomerNumber: string;
  constructor(igsCustomerNumber?: string) {
    this.igsCustomerNumber = igsCustomerNumber;
  }
}
